/* =========================================================================
   Place des Arts — « Artistes à découvrir » (page artiste).
   -------------------------------------------------------------------------
   Rend des cards artiste RÉELLES (plus de placeholder « Artiste 1/2/3 ») depuis
   l'index artistes CDN (data-artists-url, même source que le catalogue). On garde
   les artistes qui partagent ≥1 MOUVEMENT avec l'artiste courant (matching
   normalisé accents/casse : l'index a « Ecole de Paris », le metaobject « École »),
   on exclut l'artiste courant, tri par nb de mouvements partagés puis nb d'œuvres.
   Repli si trop peu : artistes « célèbres » (badge=true) par nb d'œuvres.
   Section masquée tant qu'aucun similaire (révélée en retirant `hidden`).

   Card = miroir de snippets/pda-card-artist.liquid (sous-titre = nationalité seule) :
   même œuvre ; le fichier est servi à la taille de la case (SEO 08, étape 3, 30/10).
   ========================================================================= */
(function () {
  'use strict';

  var MAX = 8;   // plafond de cards rendues
  var MIN = 4;   // en dessous, on complète avec des artistes « célèbres »

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
  }
  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }
  function normalize(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /* ── IMAGES À LA TAILLE PEINTE (SEO 08, étape 3, 30/10) ─────────────────────
   * Copie CONFORME du bloc de pda-artists-catalog.js (même grille .pda-grid--artists,
   * même index, mêmes cartes) — le test seo08-etape3-page-artiste-images vérifie que
   * les deux copies restent identiques. Raisons, mesures et constantes : là-bas.
   * Mesuré le 30/10 sur la prod : 8 originaux de 1 000 px, 0,7 à 1,2 Mio par page. */
  var LARGEURS_IMG = [240, 360, 480, 600, 720];
  var RATIO_CARTE = 4 / 5;
  function imageALaTaille(src, wh, ratioCase) {
    if (!src || !wh || !(wh[0] > 0) || !(wh[1] > 0)) return null;
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    var candidats = [];
    for (var i = 0; i < LARGEURS_IMG.length; i++) {
      if (LARGEURS_IMG[i] < wh[0]) candidats.push(src + sep + 'width=' + LARGEURS_IMG[i] + ' ' + LARGEURS_IMG[i] + 'w');
    }
    candidats.push(src + ' ' + wh[0] + 'w');
    return { srcset: candidats.join(', '), k: Math.ceil(Math.max(1, (wh[0] / wh[1]) / ratioCase) * 100) / 100 };
  }
  function sizesPour(largeurCase, k) {
    return largeurCase > 0
      ? Math.ceil(largeurCase * k) + 'px'
      : '(min-width: 768px) ' + Math.ceil(700 * k) + 'px, calc(100vw * ' + k + ')';
  }

  var ARROW_SVG =
    '<svg class="pda-card-artist__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25H5.25C4.83579 3.25 4.5 3.58579 4.5 4C4.5 4.41421 4.83579 4.75 5.25 4.75H11.25V10.75C11.25 11.1642 11.5858 11.5 12 11.5C12.4142 11.5 12.75 11.1642 12.75 10.75V4ZM4 12L4.53033 12.5303L12.5303 4.53033L12 4L11.4697 3.46967L3.46967 11.4697L4 12Z" fill="currentColor"/></svg>';

  function cardHTML(a) {
    var imgSrc = a.portrait || a.img;
    var taille = imageALaTaille(imgSrc, a.portrait ? a.portraitWH : a.imgWH, RATIO_CARTE);
    var media = imgSrc
      ? '<img src="' + escapeAttr(imgSrc) + '"' +
        (taille ? ' srcset="' + escapeAttr(taille.srcset) + '" sizes="' + escapeAttr(sizesPour(0, taille.k)) + '" data-pda-k="' + taille.k + '"' : '') +
        ' alt="' + escapeAttr(a.name || '') + '" loading="lazy" width="480" height="554">'
      : '<span class="pda-card-artist__placeholder" aria-hidden="true"></span>';
    var country = (a.nationality && a.nationality[0]) || '';
    /* Sous-titre = nationalité, LOCALISÉE à l'affichage (mesuré au run live du 25/08 :
     * cette grille rendait « France »/« Espagne » en dur dans les 5 locales — elle ne
     * passait pas par la source unique, contrairement au catalogue artistes).
     * PDA.nationaliteAffichee = assets/pda-i18n.js (defer du <head>, précède ce defer
     * de section) ; null en FR ou lookup raté ⇒ le FR de l'index reste tel quel. */
    if (country && window.PDA && typeof window.PDA.nationaliteAffichee === 'function') {
      country = window.PDA.nationaliteAffichee(country) || country;
    }
    var occLine = country
      ? '<span class="pda-card-artist__occupation">' + escapeHtml(country) + '</span>'
      : '';
    return '<div class="pda-cat__card-wrap">' +
      '<a class="pda-card-artist" href="' + escapeAttr(a.url || '#') + '" data-handle="' + escapeAttr(a.handle || '') + '">' +
        '<div class="pda-card-artist__media">' + media + '</div>' +
        '<div class="pda-card-artist__content">' +
          '<span class="pda-card-artist__top"><span class="pda-card-artist__name">' + escapeHtml(a.name || '') + '</span>' + ARROW_SVG + '</span>' +
          occLine +
        '</div>' +
      '</a></div>';
  }

  function init(root) {
    var grid = root.querySelector('[data-pda-similar-grid]');
    var url = root.getAttribute('data-artists-url');
    var curHandle = root.getAttribute('data-current-handle') || '';
    if (!grid || !url) return;

    var movements = [];
    var mvEl = root.querySelector('[data-pda-similar-movements]');
    if (mvEl) { try { movements = JSON.parse(mvEl.textContent) || []; } catch (e) {} }
    /* Case de la grille MESURÉE (auto-fill : non exprimable en vw), après le rendu et à
     * chaque redimensionnement ; sizes = case × k de l'image. */
    function ajusterSizes() {
      if (root.hidden) return;
      var media = grid.querySelector('.pda-card-artist__media');
      var l = media ? media.getBoundingClientRect().width : 0;
      if (!(l > 0)) return;
      var imgs = grid.querySelectorAll('img[data-pda-k]');
      for (var i = 0; i < imgs.length; i++) {
        var s = sizesPour(l, parseFloat(imgs[i].getAttribute('data-pda-k')));
        if (imgs[i].getAttribute('sizes') !== s) imgs[i].setAttribute('sizes', s);
      }
    }
    if (window.ResizeObserver) new ResizeObserver(ajusterSizes).observe(grid);

    var mvSet = {};
    movements.forEach(function (m) { mvSet[normalize(m)] = true; });

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (list) { if (Array.isArray(list) && list.length) render(list); })
      .catch(function () {});

    function render(list) {
      var others = list.filter(function (a) { return a.handle !== curHandle; });

      // Similaires = partagent ≥1 mouvement ; tri par mouvements partagés puis œuvres.
      var similar = [];
      if (Object.keys(mvSet).length) {
        similar = others
          .map(function (a) {
            var shared = (a.movement || []).reduce(function (n, m) { return n + (mvSet[normalize(m)] ? 1 : 0); }, 0);
            return { a: a, shared: shared };
          })
          .filter(function (x) { return x.shared > 0; })
          .sort(function (x, y) { return (y.shared - x.shared) || ((y.a.count || 0) - (x.a.count || 0)); })
          .map(function (x) { return x.a; });
      }

      // Repli : compléter avec des artistes « célèbres » (badge) par nb d'œuvres.
      if (similar.length < MIN) {
        var have = {};
        similar.forEach(function (a) { have[a.handle] = true; });
        var famous = others
          .filter(function (a) { return a.badge === true && !have[a.handle]; })
          .sort(function (x, y) { return (y.count || 0) - (x.count || 0); });
        similar = similar.concat(famous);
      }

      var chosen = similar.slice(0, MAX);
      if (!chosen.length) return; // rien de pertinent → section reste masquée
      grid.innerHTML = chosen.map(cardHTML).join('');
      root.hidden = false;
      // Même tâche que l'insertion : les images (lazy) n'ont encore choisi aucun fichier.
      ajusterSizes();
    }
  }

  function boot() { document.querySelectorAll('[data-pda-similar-artists]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
